import { createContext } from 'react';

export type UserContextType = {
  name: string;
};

export const UserContext = createContext({
  name: ''
});
